import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IAssetPermissionsDataset } from 'types/common';


interface HazardState {
  permission: IAssetPermissionsDataset | null
}

const initialState: HazardState = {
  permission: null,
};

const projectPermissionsReducer = createSlice({
  name: 'projectPermission',
  initialState,
  reducers: {
    setProjectPermission: (state, action: PayloadAction<IAssetPermissionsDataset | null>) => {
      state.permission = action.payload
    },
  },
});

export const { setProjectPermission } = projectPermissionsReducer.actions;
export default projectPermissionsReducer.reducer;
